import { DoqFaceSvgProps } from '../types';

const DoqNoAccess = ({ size, className }: DoqFaceSvgProps) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 200 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="presentation"
    >
      <g clipPath="url(#clip0_287_1615)">
        <ellipse
          cx="107.744"
          cy="109.272"
          rx="92.2559"
          ry="90.7285"
          fill="#C7C1C8"
        />
        <mask
          id="mask0_287_1615"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="15"
          y="18"
          width="185"
          height="182"
        >
          <ellipse
            cx="107.744"
            cy="109.272"
            rx="92.2559"
            ry="90.7285"
            fill="#DEDADE"
          />
        </mask>
        <g mask="url(#mask0_287_1615)">
          <rect
            width="91.9249"
            height="113.83"
            transform="matrix(0.887429 -0.460945 0.473137 0.880989 97.3241 152.205)"
            fill="white"
          />
          <g opacity="0.5">
            <path
              d="M138.603 209.641C138.455 209.364 138.562 209.021 138.844 208.875L203.086 175.507C203.367 175.36 203.716 175.466 203.865 175.743L204.403 176.746C204.552 177.023 204.444 177.366 204.163 177.512L139.921 210.88C139.64 211.027 139.291 210.921 139.142 210.644L138.603 209.641Z"
              fill="#2974C4"
            />
            <path
              d="M147.759 226.689C147.61 226.412 147.718 226.069 148 225.923L212.241 192.555C212.523 192.408 212.872 192.514 213.021 192.791L213.559 193.794C213.708 194.071 213.6 194.414 213.319 194.56L149.077 227.929C148.795 228.075 148.446 227.969 148.298 227.692L147.759 226.689Z"
              fill="#2974C4"
            />
            <path
              d="M143.153 216.897C142.871 217.044 142.763 217.387 142.912 217.664L143.451 218.667C143.599 218.943 143.948 219.049 144.23 218.903L208.471 185.535C208.753 185.389 208.861 185.046 208.712 184.769L208.173 183.766C208.025 183.489 207.676 183.383 207.394 183.529L143.153 216.897Z"
              fill="#2974C4"
            />
            <path
              d="M152.068 234.712C151.919 234.435 152.027 234.092 152.308 233.946L216.55 200.577C216.832 200.431 217.18 200.537 217.329 200.814L217.868 201.817C218.016 202.094 217.909 202.437 217.627 202.583L153.385 235.951C153.104 236.097 152.755 235.992 152.606 235.715L152.068 234.712Z"
              fill="#2974C4"
            />
          </g>
        </g>
        <path
          d="M146.169 167.876C148.422 166.706 149.284 163.962 148.094 161.746C146.904 159.531 144.114 158.684 141.861 159.854C139.608 161.024 138.746 163.768 139.936 165.984C141.126 168.199 143.917 169.046 146.169 167.876Z"
          fill="#2974C4"
        />
        <path
          d="M164.524 158.343C166.777 157.173 167.639 154.428 166.449 152.213C165.259 149.997 162.468 149.15 160.216 150.32C157.963 151.49 157.101 154.235 158.291 156.45C159.481 158.665 162.271 159.513 164.524 158.343Z"
          fill="#2974C4"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M159.146 171.397C156.126 172.965 154.356 175.948 154.234 179.078L156.739 177.777C157.199 175.964 158.411 174.344 160.223 173.402C162.035 172.461 164.079 172.39 165.86 173.039L168.366 171.738C165.668 170.072 162.165 169.829 159.146 171.397Z"
          fill="#2974C4"
        />
        <path
          d="M145.135 122.241L145.135 122.242C145.402 122.118 145.714 122.128 145.973 122.27L150.348 124.663L125.875 137.375L126.332 132.472C126.359 132.181 126.526 131.923 126.78 131.775L126.78 131.775L145.135 122.241Z"
          fill="#141414"
        />
        <path
          d="M120.377 99.1884C120.943 98.9011 121.639 99.1194 121.931 99.676L126.162 107.739C126.455 108.295 126.233 108.979 125.667 109.266C125.101 109.554 124.405 109.335 124.113 108.779L119.881 100.716C119.589 100.16 119.811 99.4757 120.377 99.1884Z"
          fill="#CB3434"
        />
        <path
          d="M142.115 99.6096C142.456 99.0809 143.169 98.9244 143.706 99.2601C144.244 99.5959 144.403 100.297 144.062 100.825L139.078 108.544C138.737 109.073 138.024 109.23 137.486 108.894C136.949 108.558 136.79 107.857 137.131 107.329L142.115 99.6096Z"
          fill="#CB3434"
        />
        <path
          d="M122.348 123.521C120.036 119.218 121.71 113.887 126.086 111.614L128.594 110.311C132.97 108.038 138.391 109.684 140.702 113.988L145.135 122.241L126.78 131.775L122.348 123.521Z"
          fill="#CB3434"
        />
        <path
          d="M145.049 118.438C144.751 117.884 144.967 117.198 145.53 116.905L154.707 112.138C155.27 111.846 155.968 112.058 156.265 112.612C156.563 113.165 156.347 113.852 155.784 114.144L146.607 118.911C146.044 119.203 145.346 118.992 145.049 118.438Z"
          fill="#CB3434"
        />
        <path
          d="M112.899 133.854C112.336 134.147 112.12 134.833 112.418 135.387C112.715 135.941 113.413 136.152 113.976 135.86L123.154 131.093C123.717 130.8 123.932 130.114 123.635 129.561C123.337 129.007 122.64 128.795 122.076 129.087L112.899 133.854Z"
          fill="#CB3434"
        />
        <path
          d="M108.285 117.658C108.306 117.032 108.84 116.542 109.476 116.563L118.768 116.866C119.405 116.887 119.904 117.412 119.883 118.038C119.861 118.664 119.328 119.154 118.692 119.133L109.4 118.83C108.763 118.809 108.264 118.284 108.285 117.658Z"
          fill="#CB3434"
        />
        <path
          d="M129.947 112.174C129.947 112.174 133.476 111.868 136.053 113.693C138.631 115.518 140.345 119.598 140.345 119.598"
          stroke="white"
          strokeWidth="1.7125"
          strokeLinecap="round"
        />
      </g>
      <path
        d="M24.014 32.8804C24.014 17.7586 36.2727 5.5 51.3945 5.5C66.5162 5.5 78.7749 17.7586 78.7749 32.8804V59.1721H24.014V32.8804Z"
        stroke="#8197B1"
        strokeWidth="11"
      />
      <rect
        y="50.3311"
        width="102.357"
        height="87.9202"
        rx="8"
        fill="#FFCA43"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M56.4526 93.0962C58.2067 91.6288 59.3195 89.4422 59.3195 87C59.3195 82.5817 55.6774 79 51.1848 79C46.6921 79 43.0501 82.5817 43.0501 87C43.0501 89.4368 44.1579 91.6191 45.9053 93.0864L41.5055 109.583H60.8498L56.4526 93.0962Z"
        fill="black"
      />
      <defs>
        <clipPath id="clip0_287_1615">
          <rect
            width="184.512"
            height="181.457"
            fill="white"
            transform="translate(15.4882 18.543)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export { DoqNoAccess };
